<template>
  <div class="admin-auth-page">
    <div class="auth-container">
      <b-field label="Email">
        <b-input type="email" v-model="email"></b-input>
      </b-field>

      <b-field label="Password">
        <b-input type="password" v-model="password" password-reveal></b-input>
     </b-field>
    
      <b-button @click="login">Login</b-button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "login",
  data() {
    return {
      email: '',
      password: ''
    };
  },
  methods: {
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(data => {
          console.log(data)
          this.$router.push('admin')
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>
